import {
  Layout,
} from "antd";
const { Footer } = Layout;

export function FooterComponent(){
  const currentYear = new Date().getFullYear();
  return (
    <Footer>
      GPS Dataviz {currentYear}
    </Footer>
  )
}